<style scoped lang="scss">
.page {
    min-height: 100vh;
    background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 60%, #f8fafc 100%);
    display: flex;
    flex-direction: column;
}

.page-main {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3.5rem 1.5rem 4rem;
    position: relative;
}

.page-main::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 15% 20%, rgba(59, 130, 246, 0.15), transparent 40%),
        radial-gradient(circle at 85% 10%, rgba(99, 102, 241, 0.15), transparent 45%);
    pointer-events: none;
}

.card {
    position: relative;
    width: min(520px, 92vw);
    background: #ffffff;
    border-radius: 1.2rem;
    border: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 20px 40px -28px rgba(15, 23, 42, 0.35);
    padding: 2.2rem 2.5rem;
    z-index: 1;
}

.card-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.5rem;

    .icon {
        width: 2.6rem;
        height: 2.6rem;
        border-radius: 0.9rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 1.35rem;
        color: #2563eb;
        background: rgba(37, 99, 235, 0.12);
        border: 1px solid rgba(37, 99, 235, 0.2);
    }
}

.title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #0f172a;
}

.subtitle {
    color: #64748b;
    font-size: 0.95rem;
    margin-bottom: 1.6rem;
}

.form-grid {
    display: grid;
    gap: 1.2rem;
}

:deep(.el-form-item__label) {
    font-weight: 600;
    color: #334155;
    font-size: 0.92rem;
    margin-bottom: 0.35rem;
}

:deep(.el-input__wrapper),
:deep(.el-select__wrapper) {
    border-radius: 0.75rem;
    padding: 0 0.9rem;
    box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.35);
    transition: all 0.2s ease;
    background: #ffffff;
    height: 2.75rem;
    align-items: center;
}

:deep(.el-input__wrapper:hover),
:deep(.el-select__wrapper:hover) {
    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.35);
}

:deep(.el-input__wrapper.is-focus),
:deep(.el-select__wrapper.is-focus),
:deep(.el-input__wrapper:focus-within),
:deep(.el-select__wrapper:focus-within) {
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.35);
}

:deep(.el-input__inner) {
    height: 2.75rem;
    font-size: 0.95rem;
    color: #0f172a;
}

:deep(.el-select__selection) {
    line-height: 2.75rem;
}

:deep(.el-select) {
    width: 100%;
}

.submit-btn {
    width: 100%;
    height: 2.8rem;
    font-size: 0.95rem;
    font-weight: 600;
    border-radius: 0.8rem;
    background: linear-gradient(135deg, #2563eb, #3b82f6);
    border: none;
    color: #ffffff;
    transition: all 0.2s ease;
    margin-top: 0.5rem;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 12px 20px -18px rgba(37, 99, 235, 0.6);
    }
}

@media screen and (max-width: 768px) {
    .card {
        padding: 1.8rem;
    }
}
</style>
<template>
    <div class="page">
        <IndexHeader />
        <main class="page-main">
            <div class="card">
                <div class="card-header">
                    <div class="title">授权查询</div>
                </div>
                <div class="subtitle">输入授权字段与插件信息，快速查询授权状态。</div>
                <el-form class="form-grid" :label-position="form_position" label-width="80px" :model="form">
                    <el-form-item label="授权字段">
                        <el-input type="text" v-model="form.host" name="host" placeholder="请输入授权字段"></el-input>
                    </el-form-item>
                    <el-form-item label="插件">
                        <el-select v-model="form.id" placeholder="请选择插件">
                            <el-option v-for="item in includes_data" :key="item.id" :label="item.id + '---' + item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-button type="primary" class="submit-btn" @click="getQuery">立即查询</el-button>
            </div>
        </main>
        <IndexFooter />
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import IndexHeader from '@/components/IndexHeader.vue'
import IndexFooter from '@/components/IndexFooter.vue'
import { getIncludesList } from '@/utils/publicMethods'
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    name: 'QueryView',
    components: {
        IndexHeader,
        IndexFooter
    },
    data() {
        return {
            form: {
                host: "",
                id: "",
            },
            includes_data: [],
            form_position:"top",
            bgImageUrl: [
                require('@/assets/img/bg2.webp'),
            require('@/assets/img/bg3.jpg'),
            require('@/assets/img/bg4.png'),
            require('@/assets/img/bg5.png'),
            require('@/assets/img/bg6.webp'),
            require('@/assets/img/bg7.webp'),
            require('@/assets/img/bg8.webp'),
            require('@/assets/img/bg9.webp'),
            ]
        }
    },
    computed: {
        bgStyle() {
            let i = Math.floor(Math.random() * this.bgImageUrl.length);
            return {
                // 'background': `url(${this.bgImageUrl[i]})`
            };
        }
    },
    methods: {
        getQuery() {
            console.log("你好");
            
            openLoading()
            axios.get(baseURL + '/getTime?host=' + this.form.host + '&id=' + this.form.id, { timeout: 30000 })
                .then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(err => {
                    this.$message.error(err);
                }).finally(() => {
                    fullscreenLoading.close()
                })

        },
        async getIncludes() {
            const res_data = await getIncludesList(999, 1);
            if (res_data.code != 0) {
                ElMessage.error(res_data.msg)
                return
            }
            this.includes_data = res_data.data
        },
        setFormPosition(){
            window.innerWidth < 768 ? this.form_position = "top" : this.form_position = "left"
        }
    },
    mounted() {
        this.getIncludes()
        this.setFormPosition()
    }
})
</script>